import SeeMoreArtworks from './SeeMoreArtworks'

export default SeeMoreArtworks
